export default __webpack_public_path__ + "static/media/play.b4ecb020.svg";